import { api } from '../axiosClient';
import { PERSONAL_EXPENSES_BASE_PATH } from './constants';
import type {
  CreatePersonalExpensePayload,
  PatchPersonalExpensePayload,
  RESTPersonalExpense,
} from './personalExpenses.types';

export const getPersonalExpense = (
  id: number,
): Promise<RESTPersonalExpense> => {
  return api.get(`${PERSONAL_EXPENSES_BASE_PATH}/${id}`);
};

export const postPersonalExpense = (
  data: CreatePersonalExpensePayload,
): Promise<RESTPersonalExpense & { expenseId: number }> => {
  return api.post(`${PERSONAL_EXPENSES_BASE_PATH}`, data);
};

export const patchPersonalExpense = (
  id: number,
  data: PatchPersonalExpensePayload,
): Promise<RESTPersonalExpense & { expenseId: number }> => {
  return api.patch(`${PERSONAL_EXPENSES_BASE_PATH}/${id}`, data);
};

export const deletePersonalExpense = (id: number): Promise<void> => {
  return api.delete(`${PERSONAL_EXPENSES_BASE_PATH}/${id}`);
};
